import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-line-events-exercise-performance',
  templateUrl: './line-events-exercise-performance.component.html',
  styleUrl: './line-events-exercise-performance.component.scss',
})
export class LineEventsExercisePerformanceComponent {
  isLoading = true;

  options: echarts.EChartsOption = {
    grid: { left: 20, right: 20, top: 40, bottom: 80 },

    yAxis: [
      {
        type: 'value',
        position: 'left',
        max: 100,
        name: this.translateService.instant('charts.labels.percentage'),
        nameLocation: 'middle', // position along axis (top | middle | bottom)
        nameGap: 40, // distance from axis
        nameTextStyle: {
          fontSize: 12,
          fontWeight: 'bold',
        },
        axisLabel: {
          formatter: '{value}%', // append percentage sign to labels
        },
      },
      {
        type: 'value',
        position: 'right',
        name: this.translateService.instant('charts.labels.count'),
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: {
          fontSize: 12,
          fontWeight: 'bold',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 1,
        itemStyle: {
          color: '#6FFACC',
          borderColor: '#6FFACC',
          borderWidth: 4,
        },
      },
      {
        type: 'bar',
        stack: 'total',
        yAxisIndex: 0,
        label: {
          show: true,
          position: 'inside',
          formatter: '{c}%', // show the percentage value
          fontWeight: 'bold',
          color: '#fff',
        },
        itemStyle: {},
      },
      {
        type: 'bar',
        stack: 'total',
        yAxisIndex: 0,
        label: {
          show: true,
          position: 'inside',
          formatter: '{c}%', // show the percentage value
          fontWeight: 'bold',
          color: '#fff',
        },
        itemStyle: {},
      },
    ],
  };

  constructor(
    protected analyticsService: AnalyticsService,
    public translateService: TranslateService
  ) {
    this.analyticsService.lineEventExercisePerformance$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('lineEventExercisePerformance');
    });
    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getLineEventExercisePerformance().subscribe();
  }

  get series() {
    return this.analyticsService.lineEventExercisePerformance$.value?.series;
  }

  get labels() {
    return this.analyticsService.lineEventExercisePerformance$.value?.labels;
  }
}
